import {
    IElementBaseModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IParagraph } from '../text/interface/editor-para.interface';
import { DatetimeFieldType } from '../text/utils/format-datetime';

export enum DatetimeType {
    FIXED = '0',
    AUTO_UPDATE = '1',
}
export interface ISlideFooter {
    /**
     * 侧边栏页脚元素勾选回调
     * @param props
     */
    updatePlaceholderFormat(props: IFooterProps): void;
    getDatetimeParagraphList(): IParagraph[]|undefined;
    getDatetimeType(): DatetimeType;
    getCurrentSlideFooterContent(): string;
    getCurrentDatetimeText(): string;
    updateDatetimeContent(value: string): void;
    updateSlideFooterContent(value: string): void;
    updateDatetimeFieldType(type: DatetimeFieldType): void;
    getDatetimeFieldType(): string;
    updateDatetimeType(value: DatetimeType): void;
}

export interface IFooterProps {
    value: string;
    checked: boolean;
    targetShape?: IElementBaseModel;
}
